import { getLayoutData, getPageData } from './api/api';
import { FRAGMENTS } from '@repo/ui/lib';
import { DIGITAL_FRAGMENTS } from '@/lib';
import dynamic from 'next/dynamic';
import ExtendedContent from '@/components/common/ExtendedContent';

const StickyHeading = dynamic(() => import('@repo/ui/src/components/StickyHeading'), {
	ssr: false,
});

export default function Home({ data, locale }) {
	const contentData = data?.content || [];
	const stickyHeadingsSelectors = data?.stickyHeadingsSelector || [];
	return (
		<>
			<StickyHeading stickyHeadingsSelectors={stickyHeadingsSelectors} isVisible />
			<ExtendedContent content={contentData} locale={locale} hidePleoTags={true} disableServicesSlider={true} />
		</>
	);
}

const PAGE_CONTENT_TYPE = 'allDigitalSinglePages';

const SINGLE_PAGES_QUERY = `
	query GetHomePageData($locale: SiteLocale) {
		${PAGE_CONTENT_TYPE}(locale: $locale, filter: {slug: {eq: "home"}}) {
            name
            slug
            description
            ${FRAGMENTS.SEO_META_FRAGMENT}
            ${FRAGMENTS.THEME_FRAGMENT}
            ${DIGITAL_FRAGMENTS.BREADCRUMBS_FRAGMENT}
			${DIGITAL_FRAGMENTS.STICKY_HEADING_FRAGMENT}
			content{
				__typename
				${FRAGMENTS.VIDEO_BANNER_FRAGMENT}
			  	${FRAGMENTS.DESCRIPTION_AND_SLOGAN_MODULE_FRAGMENT}
				${FRAGMENTS.HORIZONTAL_HEADER_MODULE_FRAGMENT}
				${FRAGMENTS.TEXT_MODULE_FRAGMENT}
				${FRAGMENTS.WHO_WE_WORKED_WITH_MODULE_FRAGMENT}
				
				${DIGITAL_FRAGMENTS.SINGLE_ASSET_FRAGMENT}
				${DIGITAL_FRAGMENTS.CHECK_OTHERS_FRAGMENT}
				${DIGITAL_FRAGMENTS.SOCIAL_MEDIA_FRAGMENT}
			  	${DIGITAL_FRAGMENTS.BLOB_SLOGAN_FRAGMENT}
			  	${DIGITAL_FRAGMENTS.DESCRIPTION_LOGO_PLEO_FRAGMENT}
			  	${DIGITAL_FRAGMENTS.FEATURED_PROJECTS_FRAGMENT}
			  	${DIGITAL_FRAGMENTS.HOW_WE_CREATE_STORY_FRAGMENT}
			  	${DIGITAL_FRAGMENTS.NEWS_THUMBNAILS_FRAGMENT}
			}
		}
	}
`;

export async function getStaticProps(context) {
	const locale = context?.locale || 'pl';
	const data = await getPageData(PAGE_CONTENT_TYPE, 'home', SINGLE_PAGES_QUERY, locale);
	const { globals, cookies, menu, footer } = await getLayoutData(locale);
	return {
		props: {
			data,
			globals,
			cookies,
			locale,
			menu,
			footer,
		},
		revalidate: 120,
	};
}
